<template>

    <trax-ui-ajax-table-with-crud-actions
        :id="id" :titles="titles" :props="props" :bus="bus"
        :endpoint="endpoint" :delete="false" :paging="false">
    </trax-ui-ajax-table-with-crud-actions>

</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            endpoint: null
        },

        data: function() {
            return {
                lang: lang,
                titles: [
                    lang.polaris.settings.aircraft_code,
                    lang.polaris.form.name,
                    lang.polaris.form.status,
                    ''
                ],
                props: [
                    {source: 'code', class: 'font-weight-bold'},
                    {source: 'name'},
                    {source: this.status}
                ]
            }
        },

        methods: {

            // Columns rendering

            status(data, type, row, meta) {
                if (row.active) {
                    return '<span class="badge badge-success">'
                        + this.lang.polaris.settings.aircraft_enabled + '</span>';
                }
                return '<span class="badge badge-default">'
                    + this.lang.polaris.settings.aircraft_disabled + '</span>';
            }
        }

    }
</script>
